const contentPreviewSettings = {
  queryKey: "preview_for",
  supportedValues: {
    google_classroom: {
      headerContents: 'Close preview and select "Add" to include content',
    },
    canvas: {
      headerContents: 'Close preview and select "Add" to include content',
    },
    schoology: {
      headerContents: 'Close preview and select "Add" to include content',
    },
    desire2learn: {
      headerContents: 'Close preview and select "Add" to include content',
    },
  },
};

export default contentPreviewSettings;
